import HttpUtil from '@/util/HttpUtil'

export const Langs = [
  'es'
]

export function RemoteLoader (resolve, reject) {
  let httpClient = new HttpUtil()
  httpClient.getInstance().get('language/es')
    .then(response => {
      resolve && resolve('es', response.data)
    })
    .catch(reject)
}



// WEBPACK FOOTER //
// ./src/customization/GlobalBPOCore/langs.js